import { render, staticRenderFns } from "./ConstructionDashboard.vue?vue&type=template&id=39bd3576"
import script from "./ConstructionDashboard.vue?vue&type=script&lang=js"
export * from "./ConstructionDashboard.vue?vue&type=script&lang=js"
import style0 from "./ConstructionDashboard.vue?vue&type=style&index=0&id=39bd3576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
